import  "./Home.scss";

export default function Home() {
    return (
        <div>
            <h1>HOlA Marshall!!!!</h1>
        </div>
    );
}
